// extracted by mini-css-extract-plugin
export default {"form":"loginForm_form__J2WIh","perdeu":"loginForm_perdeu__blPx8","cadastro":"loginForm_cadastro__MjDrd","subtitle":"loginForm_subtitle__gHJ2f"};